import React from "react";
import Sidenavdoctor from "./Sidenavdoctor";
import Doctorpatientdtails1 from "./Doctorpatientdetails1";
import Doctorpatientdtails2 from "./Doctorpatientdtails2";


function Dallpatient () {
    return(
      
        <>
        <Sidenavdoctor/>
        <Doctorpatientdtails1/>
        <Doctorpatientdtails2/>
        </>
    )
}

export default Dallpatient;